import React, { createContext, useState } from "react";
import { API_Path } from "../Const";
import { GetApi } from "../api/api-service";

export const StoreContext = createContext();

export const MyProvider = ({ children }) => {
    const [isLoader, setIsLoader] = useState(false);
    const [remLoader, setREMLoader] = useState(false);
    const [monetariesProperties, setMonetariesProperties] = useState({});
    const [DeveloperData, setDeveloperData] = useState({});
    const [mediaProject, setMediaProject] = useState({});
    const [propertybyProject, setPropertybyProject] = useState([]);
    const [recommendationsData, setRecommendationsData] = useState([]);
    const [similarPjtsData, setSimilarPjtsData] = useState([]);
    const [localityData, setLocalityData] = useState([]);

    const fetchMonetariesProperties = async (id) => {
        try {
            setIsLoader(true);
            let res = await GetApi(API_Path.propertiesDetails + `/frame/monetaries/${id}`);
            if (res && res.data.success) setMonetariesProperties(res.data.data);
            setIsLoader(false);
        } catch (error) {
            console.error("Error:", error);
        }
    };
    const fetchRecommendProperties = async (id) => {
        try {
            setREMLoader(true);
            let res = await GetApi(API_Path.recommendPtsDetails + `${id}`);
            if (res && res.data.success) setRecommendationsData(res.data.data);
            setREMLoader(false);
        } catch (error) {
            setREMLoader(false);
            console.error("Error:", error);
        }
    };
    const fetchSimilarPjts = async (id) => {
        try {
            setIsLoader(true);
            let res = await GetApi(API_Path.similarPjtsDetails + `${id}`);
            if (res && res.data.success) setSimilarPjtsData(res.data.data);
            setIsLoader(false);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const fetchDeveloper = async (id) => {
        try {
            setIsLoader(true);
            let res = await GetApi(API_Path.DeveloperDetails + `/${id}`);
            if (res && res.data.success) setDeveloperData(res.data.data);
            setIsLoader(false);
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const fetchMediaProject = async (id) => {
        try {
            setIsLoader(true);
            let res = await GetApi(API_Path.ProjectsDetails + `/media/${id}`);
            if (res && res.data.success) setMediaProject(res.data.data);
            setIsLoader(false);
        } catch (error) {
            console.error("Error:", error);
        }
    };
    const fetchPropertybyProject = async (page, id) => {
        try {
            setIsLoader(true);
            let res = await GetApi(API_Path.propertiesDetails + `/${id}?pageNumber=${page}&pageSize=10`);
            if (res && res.data.success) setPropertybyProject(res.data.data);
            setIsLoader(false);
        } catch (error) {
            console.error("Error:", error);
        }
    };
    const fatchLocality = async () => {
        try {
            const res = await GetApi(API_Path.propertiesDetails + "/Locality");
            if (res?.data?.success) {
                let data = res.data.data;
                const formattedNames = data.map((name) => ({ name: name.trim() }));
                setLocalityData(formattedNames);
            }
        } catch (error) {
            console.error("Error fetching area units:", error);
        }
    };

    return (
        <StoreContext.Provider
            value={{
                isLoader,
                monetariesProperties,
                fetchMonetariesProperties,
                mediaProject,
                fetchMediaProject,
                DeveloperData,
                fetchDeveloper,
                propertybyProject,
                fetchPropertybyProject,
                remLoader,
                recommendationsData,
                fetchRecommendProperties,
                similarPjtsData,
                fetchSimilarPjts,
                localityData,
                fatchLocality,
            }}
        >
            {children}
        </StoreContext.Provider>
    );
};
